// src/axiosInstance.js
import axios from "axios";
import URL from "../config/apiUrl";

const axiosInstance = axios.create({
  baseURL: URL, // Replace with your API base URL
  timeout: 100000,
  headers: { "Content-Type": "application/json" },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    // Do something before the request is sent
    let token = localStorage.getItem("spektorAdminUser"); // Retrieve auth token from localStorage

    if (token) {
      token = token.replace(/^"(.*)"$/, "$1");
      // Set the x-auth-token header instead of Authorization
      config.headers["x-auth-token"] = token;
    }
    return config;
  },
  function (error) {
    // Handle the error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // Handle the response error
    if (error.response && error.response.status === 401) {
      // Remove the token from localStorage
      localStorage.removeItem("spektorAdminUser");
      console.error("Unauthorized, logging out...");

      // Optionally redirect to the login page
      window.location.href = "/login"; // Adjust the path as needed
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
